/*
 * @Description:
 * @Author: miaomiao
 * @Date: 2021-01-05 13:49:47
 * @LastEditTime: 2022-06-22 14:34:06
 * @LastEditors: JikeyChang
 */
function loadFiles(files) {
  const modules = {};
  files.keys().forEach((key) => {
    modules[key.replace(/(\.\/|\.js)/g, '')] = files(key).default;
  });
  return modules;
}
/*
 一级模块文件夹
 */
// 系统基础，不要移除和变更
const system = loadFiles(require.context('./system', false, /\.js$/));
// 以下是项目内的
const module1 = loadFiles(require.context('./module1', false, /\.js$/));
const list = loadFiles(require.context('./list', false, /\.js$/));
const virtualStore = loadFiles(require.context('./virtual', false, /\.js$/));
const proMasterData = loadFiles(require.context('./masterData', false, /\.js$/));
const ums = loadFiles(require.context('./ums', false, /\.js$/));
const common = loadFiles(require.context('./common', false, /\.js$/));
const feishu = loadFiles(require.context('./feishu', false, /\.js$/));

// 导出模块,每个子模块个性化，可以自行设置
export default {
  system: {
    namespaced: true,
    state: { name: 'system' },
    modules: system,
  },
  module1: {
    namespaced: true,
    actions: {},
    modules: module1,
  },
  list: {
    namespaced: true,
    actions: {},
    modules: list,
  },
  virtualStore: {
    namespaced: true,
    actions: {},
    modules: virtualStore,
  },
  proMasterData: {
    namespaced: true,
    actions: {},
    modules: proMasterData,
  },
  ums: {
    namespaced: true,
    actions: {},
    modules: ums,
  },
  common: {
    namespaced: true,
    actions: {},
    modules: common,
  },
  feishu: {
    namespaced: true,
    actions: {},
    modules: feishu,
  },
};
